export default "__VITE_ASSET__CetOpe3m__"